let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("4UYlu")).then(() => parcelRequire('e7zr1'));